/*************************************************/
/* HIGHLIGHT-BOX                                 */
/*************************************************/
export function highlightBox() {
    const collapsedTextTriggerSelector = ".highlight-box__expand-text-trigger";
    const collapsedTextParentClass = "highlight-box__text--collapsed";
    const highlightBoxElementSelector = ".highlight-box";



    const init = () => {
        const triggers = document.querySelectorAll(collapsedTextTriggerSelector);
        if (triggers) {
            triggers.forEach(trigger => {
                trigger.addEventListener('click', e => {
                    //We set the max height of the entire highlight box first
                    const highlightBox = trigger.closest(highlightBoxElementSelector);
                    const height = highlightBox.offsetHeight;
                    highlightBox.style.height = height + "px";

                    //Then we do all the showing of the text
                    const collapseParent = trigger.parentElement.previousElementSibling
                    collapseParent.style.maxHeight = collapseParent.scrollHeight + "px";
                    collapseParent.classList.remove(collapsedTextParentClass);
                    trigger.remove();

                    //We "remove" the max height after the animation has run so the text remains visible when resized
                    setTimeout(() => {
                        collapseParent.style.maxHeight = "100%";
                    },400);
                });
            });
        }
    };

    init();

}

